import React from 'react';
import {
    Box,
    List,
    ListItemButton,
    ListItemText,
    Menu,
    MenuItem,
    Radio,
    Typography,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { OrganizeIcon, RadioBtnActiveIcon, RadioBtnNonActiveIcon } from '../../../icons'; // Adjust path if needed
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';

const MainTableSec = ({
    selectedOption,
    anchorEl,
    handleOpenMenu,
    handleMenuItemClick,
    handleCloseMenu,
    organizeOptions = ['Date', 'Project', 'Member'],
    companyName = 'Acadecraft Private Limited',
    timezone = 'Asia - Kolkata',
}) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
                <Typography sx={{ color: '#1A1F36', fontSize: '17px', fontWeight: 600 }}>
                    {companyName}
                </Typography>
                <Typography sx={{ fontSize: '14px', color: '#9095A1' }}>{timezone}</Typography>
            </Box>

            <List component="nav">
                <ListItemButton
                    onClick={handleOpenMenu}
                    sx={{
                        border: '1px solid #ccc',
                        borderRadius: '50px',
                        display: 'inline-flex',
                        padding: '0px 16px 0px 15px',
                        alignItems: 'center',
                        background: '#fff',
                        gap: 1,
                    }}
                >
                    <ListItemText
                        sx={{ display: 'flex', alignItems: 'center', color: '#64748B', gap: '10px' }}
                        primary={
                            <Box display="flex" alignItems="center" gap={1}>
                                <OrganizeIcon fontSize="small" />
                                <Typography fontWeight="medium" sx={{ textTransform: 'uppercase', fontSize: '14px', }}>Organize by:</Typography>
                            </Box>
                        }
                        secondary={selectedOption}
                        secondaryTypographyProps={{ sx: { color: '#0076FE', fontWeight: 500 } }}
                    />
                    <KeyboardArrowDownIcon sx={{ color: '#64748B', marginLeft: '20px' }} />
                </ListItemButton>
            </List>

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu} PaperProps={{
                sx: {
                    borderRadius: '8px',
                },
            }}>
                {organizeOptions.map((option) => (
                    <MenuItem
                        key={option}
                        selected={selectedOption === option}
                        onClick={() => handleMenuItemClick(option)}
                        sx={{
                            fontSize: '12px',
                            minWidth: '220px',
                            '& span': {
                                padding: '0 10px 0 0',
                            },
                        }}
                    >
                        <Radio
                            checked={selectedOption === option}
                            value={option}
                            icon={<RadioBtnNonActiveIcon />}
                            checkedIcon={<RadioBtnActiveIcon sx={{ color: '#0076FE' }} />}
                        />

                        {option}
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
};

export default MainTableSec;
